<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap check-in"
  >
    <h3>
      {{ $t('preCheckIn.checkIn.title') }}
    </h3>
    <el-form
      :model="userData"
      :rules="rules"
      label-position="top"
      class="checkin-form pre-reg"
      :ref="formName"
      autocomplete="off"
      @submit.native.prevent
    >
      <el-row class="block">
        <LoginForm
          :model="userData"
          :dob.sync="userData.dob"
          ref="loginForm"
        />
        <el-form-item class="submit-container">
          <el-form-item class="submit-btn">
            <el-button
              type="primary"
              @click="submitForm('checkInForm')"
            >
              {{ $t('common.buttons.next') }}
            </el-button>
          </el-form-item>
        </el-form-item>
      </el-row>
    </el-form>
    <el-row class="info">
      {{ $t('preCheckIn.checkIn.info') }}
    </el-row>
  </el-row>
</template>

<script>

import LoginForm from '../components/LoginForm';

export default {
  name: "CheckIn",
  components: {
    LoginForm
  },
  data: () => ({
    fullscreenLoading: false,
    userData: {},
    sid: null,
    activeStep: 'check-in',
    patientNumber: null,
    patientId: null,
    routerName: 'UploadPhoto',
    formName: 'checkInForm',
    msg: null,
    rules: {},
    fields: ['dob']
  }),
  created(){
    this.setProgressBar();
    this.setRules(this.fields);
    this.fullscreenLoading = true;
    this.patientId = this.$route.params.pid;
    this.sid = this.getSessionId();
    this.saveStatisticData(this.sid, {
      active_step: this.activeStep,
      render_CheckIn : 'true',
      authSource: 'SO'
    });
    if (this.patientId) {
      this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getUserData',{
        pid: this.patientId
      }).then((response) => {
        if (response.data.appData && response.data.appData.appointmentId) {
          this.$set(this, 'userData', response.data.appData);
          this.$refs.loginForm.dob = this.userData.dob;
          this.$refs.loginForm.patient = this.$route.params.pid
          this.fullscreenLoading = false;
          this.saveStatisticData(this.sid, {
            dob: this.formattedDate(this.userData.dob),
            fname: this.userData.fname,
            lname: this.userData.lname
          });
        } else {
          this.setMessage(this.$t('common.errors.fail'));
          this.goToMainPage();
        }
      }).catch(() => {
        this.setMessage(this.$t('common.errors.get', { type: this.$t('common.labels.dob').toLowerCase() }));
        this.fullscreenLoading = false;
      });
    } else {
      this.goToMainPage();
    }
  },
  methods: {
    savePatientData() {
      this.fullscreenLoading = true;
      return this.$axios("/Patient/Authenticate", {
        method: 'POST',
        data: {
          dateOfBirth: this.userData.dob,
          firstName: this.userData.fname,
          lastName: this.userData.lname,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          sessionStorage.setItem('patientApiToken', response.data.data.accessToken);
          const tokenData = this.parseToken(response.data.data.accessToken);
          this.saveStatisticData(this.sid, {
            patient_number: tokenData.patient_number,
            login: 'true'
          });
          if (this.userData.active_route) {
            this.fullscreenLoading = false;
            this.$router.push({
              name: this.userData.active_route,
              params: {
                patientNumber: tokenData.patient_number,
              },
            });
          } else {
            this.updateStepsData(tokenData.patient_id,{[this.activeStep]: 1}).then((response) => {
              if (response.data.isSuccess) {
                this.fullscreenLoading = false;
                this.$router.push({
                  name: this.routerName,
                  params: {
                    patientNumber: tokenData.patient_number,
                  },
                });
              } else {
                this.fullscreenLoading = false;
                this.setMessage(this.$t('common.errors.incorrectData'));
              }
            }).catch(() => {
              this.setMessage(this.$t('common.errors.get', { type: this.$t('common.labels.dob').toLowerCase() }));
              this.fullscreenLoading = false;
            });
          }
        } else {
          this.fullscreenLoading = false;
          this.setMessage(this.$t('common.errors.fail'));
        }
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.incorrectData'));
      });
    },
    submitForm() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          this.saveStatisticData(this.sid, {
            submit_CheckIn: 'true'
          });
          this.savePatientData();
        } else {
          this.fullscreenLoading = false;
          return false;
        }
      });
    },
  }
};
</script>
